import { useSelector } from 'react-redux';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

// Shares are server-paginated newest-first, so the header is display-only (no
// client-side sort that would only reorder the current page).
const rows = [
    { id: 'userId', disablePadding: true, label: 'User' },
    { id: 'day', disablePadding: false, label: 'Day' },
    { id: 'enrollmentId', disablePadding: false, label: 'Period (Enrollment)' },
    { id: 'caption', disablePadding: false, label: 'Caption' },
    { id: 'createdAt', disablePadding: false, label: 'Uploaded' },
    { id: 'actions', disablePadding: false, label: '' },
];

const MatTableHead = () => {
    const rtl = useSelector((state: { rtl: { direction: string } }) => state.rtl);

    return (
        <TableHead>
            <TableRow>
                {rows.map((row) => (
                    <TableCell key={row.id} align={rtl.direction === 'rtl' ? 'right' : 'left'} padding={row.disablePadding ? 'none' : 'normal'}>
                        {row.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default MatTableHead;
